module.exports = __webpack_public_path__ + "images/icons_v2/star-filled-5a1dd46e.svg";